export type SearchSource = 'all' | 'local' | 'network';
export function normalizeSearchSource(value: unknown): SearchSource {
  if (value === 'local' || value === 'webdav') return 'local';
  if (value === 'network' || value === 'yuxi' || value === 'yuningxi') return 'network';
  return 'all';
}
export const includesSearchLibrary = (value: unknown) => normalizeSearchSource(value) !== 'network';
export function searchSourceIds(value: unknown, preferences: Record<string, boolean> = {}) {
  const source = normalizeSearchSource(value);
  return (source === 'local' ? [] : source === 'network' ? ['yuxi', 'yuningxi'] : ['yuxi', 'yuningxi', 'webdav']).filter(id => preferences[id] !== false);
}
